import { Dropdown } from "primereact/dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGatePassRequest } from "../../../Hooks/Features/Gatepass/useGatePassRequest";
import _ from "underscore";
import { calculateWordsFromString, timePickerMuiCss, timeStringToDate } from "../../../utils/Helper";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

const GetPassRequest = ({ filterOptions, editUser, onClose, userShiftTime }) => {

    const { handleUser, handleLeaveRequest, handleClearRequest, btnLoader, fieldValues, setFieldValues, isRequestOpen, shiftEndDate } = useGatePassRequest({ filterOptions, editUser, onClose, userShiftTime });
    return (
        <div>
            <div >User Name:</div>
            <Dropdown value={fieldValues?.user} onChange={(e) => handleUser(e.value)} options={filterOptions?.user} disabled={!_.isEmpty(editUser)} optionLabel="user_display_name" placeholder="User" filter showClear filterInputAutoFocus className='input-dd' />
            <div className="mt-2 d-flex gap-2 align-items-center   ">
                <div>
                    <div>Leave Type:</div>
                    <div className='d-flex gap-2  flex-warp '>
                        {filterOptions?.leave_type?.map((item, index) => (
                            <div key={index} className={`border mt-1 p-2 rounded help-desk-popup-roles ${item?.leave_type_id === fieldValues?.leave_type?.leave_type_id ? "helpdesk-popup-role-active" : ""}`} onClick={() => setFieldValues((prev) => ({ ...prev, leave_type: item }))}>
                                <span>{item?.leave_type_name}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="w25">
                    <div >Out Time:</div>
                    <div>
                        <TimePicker label="Select Time" value={fieldValues?.out_time || null} onChange={(e) => setFieldValues((prev) => ({ ...prev, out_time: e }))} sx={{ ...timePickerMuiCss, marginTop: "0.25rem" }} 
                        minTime={new Date()}
                            slotProps={{
                                textField: {
                                    label: undefined,
                                    error: !_.isEmpty(editUser) ? false : (fieldValues?.out_time ? new Date(fieldValues?.out_time) < new Date() : false)
                                }
                            }}
                        />
                    </div>
                </div>
                {isRequestOpen && (
                    <div className="w25">
                        <div>In Time:</div>
                        <div>
                            <TimePicker label="Select Time" value={fieldValues?.in_time || null} onChange={(e) => setFieldValues((prev) => ({ ...prev, in_time: e }))} sx={{ ...timePickerMuiCss, marginTop: "0.25rem" }} minTime={new Date()} maxTime={timeStringToDate(shiftEndDate || "00:00:00")}
                                slotProps={{
                                    textField: {
                                        label: undefined,
                                        error: fieldValues?.in_time ? ((new Date(fieldValues?.in_time) < new Date()) || (new Date(fieldValues?.in_time) > timeStringToDate(shiftEndDate, new Date()))) : false
                                    }
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
            {isRequestOpen && (
                <div className="notes">
                    Please apply leave if the "In Time" is more than 1 hours earlier than out time.
                </div>
            )}

            <div className="mt-2">Approver:</div>
            <div className='d-flex gap-2 flex-wrap'>
                {filterOptions?.approved_by?.map((key, index) => (
                    <div key={index} className='d-flex align-items-center'>
                        <input type="radio" onChange={() => setFieldValues((prev) => ({ ...prev, approver: key }))} id={key?.user_code} name="approver" checked={key?.employee_id === fieldValues?.approver?.employee_id} className='c-pointer' />
                        <label htmlFor={key?.user_code} className='c-pointer'>{key?.user_display_name}</label>
                    </div>
                ))}
            </div>
            <div className="mt-2">Reason:</div>
            <textarea value={fieldValues?.reason} rows="2" className="form-control" onChange={(e) => setFieldValues((prev) => ({ ...prev, reason: e.target.value }))} style={{ resize: "none" }} />
            <div className="d-flex justify-content-between mt-2 ">
                <div>{calculateWordsFromString(fieldValues?.reason) <= 5 && calculateWordsFromString(fieldValues?.reason) + "/5 words"}</div>
                <div className="d-flex align-items-center">
                    <button onClick={handleClearRequest} className="button btn-default">
                        <FontAwesomeIcon icon="fa-solid fa-xmark" /> Clear
                    </button>
                    <div>
                        {btnLoader ? <button className="button btn-primary" style={{ width: "70px", height: "30px" }}>
                            <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button onClick={() => handleLeaveRequest()} className="button btn-primary"> <FontAwesomeIcon icon="fa-solid fa-check" /> Apply </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GetPassRequest